import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { JobTypeLResponse } from '@doda/api-client/aspida/@types';
import { cassifyListAsLMS } from '@doda/common/src/utils/convArrayUtil';
import {
  OCCUPATION_OTHER_TECHNICAL_POSITIONS,
  OCCUPATION_TECHNICAL_WRITER,
} from '@doda/common/src/constants/seo';

/**
 * 職種のAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @param occupations 職種のマスタ
 * @returns 職種のAPIリクエスト
 */
export const createOccupationApiRequest = (
  queryParams: AppQueryParams,
  occupations: JobTypeLResponse[] | null
) => {
  let occupationName = '';
  let requestOccupationLId = '';
  let requestOccupationMId = '';
  let requestOccupationSId = '';

  const occupation = cassifyListAsLMS(queryParams.oc);
  const occupationsMList = occupations?.flatMap(
    (ocValue) => ocValue.jobTypeMList
  );
  if (occupation.lList) {
    // 職種大
    const [lList] = occupation.lList;
    const findOcL = occupations?.find((ocL) => ocL.searchJobTypeId === lList);
    if (findOcL) {
      occupationName = findOcL.searchJobTypeName;
      requestOccupationLId = occupation.lList.toString();
    } else {
      // マスタに存在する値かの判定
      throw new Error('パラメータの不正(oc)');
    }
  } else if (occupation.mList) {
    // 職種中
    const [mList] = occupation.mList;
    const findOcM = occupationsMList?.find(
      (ocM) => ocM.searchJobTypeId === mList
    );
    if (
      mList === OCCUPATION_OTHER_TECHNICAL_POSITIONS ||
      mList === OCCUPATION_TECHNICAL_WRITER
    ) {
      // その他技術職（機械・電気）、テクニカルライター（マニュアル制作）は対象外
      throw new Error('パラメータの不正(oc)');
    }
    if (findOcM) {
      occupationName = findOcM.searchJobTypeName;
      requestOccupationMId = occupation.mList.toString();
    } else {
      // マスタに存在する値かの判定
      throw new Error('パラメータの不正(oc)');
    }
  } else if (occupation.sList) {
    // 職種小
    const occupationsSList = occupationsMList?.flatMap(
      (ocValue) => ocValue.jobTypeSList
    );
    const [sList] = occupation.sList;
    const findOcS = occupationsSList?.find(
      (ocS) => ocS.searchJobTypeId === sList
    );
    if (findOcS) {
      occupationName = findOcS.searchJobTypeName;
      requestOccupationSId = occupation.sList.toString();
    } else {
      // マスタに存在する値かの判定
      throw new Error('パラメータの不正(oc)');
    }
  } else {
    throw new Error('パラメータの不正(oc)');
  }

  return {
    occupationName,
    requestOccupationLId,
    requestOccupationMId,
    requestOccupationSId,
  };
};
